import {
  SetMapCybersecurityListAction,
  SetMapCybersecurityAction,
  SetObjectsLoading,
  CybersecurityMapActionsEnum,
  ICybersecurityInfoState,
} from "./types";
import { AppDispatch, RootState, getStoreState, store } from "../../../..";
import { cybersecurityService } from "../../../../api/CybersecurityService";
import {
  CyberSecurityListItem,
  IReqCybersecurityObjects,
} from "../../../../../models/CybersecurityObject";
import { MapInterfaceActionCreator } from "../../mapInterface/action.creators";
import { ISuggestion } from "../../../../../models/Search";
import { limit } from "../../../../../constants/mapConstants";
import { cyberSecurityServiceCategories } from "../../../../../constants/constants";

function getKeywordsFromActiveSuggestions(
  activeSuggestions: ISuggestion[]
): string[] {
  return activeSuggestions
    .filter((suggestion) => suggestion.type === "Ключове слово")
    .map((suggestion) => suggestion.code);
}

function getEdrpouFromActiveSuggestions(
  activeSuggestions: ISuggestion[]
): string[] {
  return activeSuggestions
    .filter((suggestion) => suggestion.type === "Юридична особа")
    .map((suggestion) => suggestion.code);
}

function getRegionsFromActiveSuggestions(
  activeSuggestions: ISuggestion[]
): string[] {
  return activeSuggestions
    .filter((suggestion) => suggestion.type === "Регіон")
    .map((suggestion) => suggestion.code);
}

export const CybersecurityActionCreators = {
  setObjectsLoading: (payload: boolean): SetObjectsLoading => ({
    type: CybersecurityMapActionsEnum.SET_IS_CYBERSECURITY_LOADING,
    payload,
  }),

  setSelectedCybersecurityObject: (
    payload: CyberSecurityListItem
  ): SetMapCybersecurityAction => ({
    type: CybersecurityMapActionsEnum.SET_SELECTED_CYBERSECURITY_OBJECT,
    payload,
  }),

  setCybersecurityInfoState: (
    payload: ICybersecurityInfoState
  ): SetMapCybersecurityListAction => {
    return {
      type: CybersecurityMapActionsEnum.SET_MAP_CYBERSECURITY_LIST,
      payload,
    };
  },
  getCybersecurityList: () => async (dispatch: AppDispatch) => {
    const servicesCategoriesFlags: { [key: string]: boolean } = (function () {
      const flags: { [key: string]: boolean } = {};
      store
        .getState()
        .cybersecurityMapFilters.service_category.forEach((category) => {
          if (cyberSecurityServiceCategories.includes(category)) {
            flags[category] = true;
          }
        });
      return flags;
    })();

    const data: IReqCybersecurityObjects = {
      ...servicesCategoriesFlags,
      keyword: [
        ...getKeywordsFromActiveSuggestions(
          store.getState().cybersecurityMapFilters.activeSuggestions
        ),
        ...(store.getState().mapFilters.keyword || []),
      ],
      edrpou: getEdrpouFromActiveSuggestions(
        store.getState().cybersecurityMapFilters.activeSuggestions
      ),
      region: getRegionsFromActiveSuggestions(
        store.getState().cybersecurityMapFilters.activeSuggestions
      ),
      account_id: store.getState().currentAccount.id,
      limit: limit,
      offset: store.getState().mapInterface.offset,

      company_size: store.getState().cybersecurityMapFilters.company_size.length
        ? store.getState().cybersecurityMapFilters.company_size
        : undefined,
      registration_date__gte: store.getState().cybersecurityMapFilters
        .registration_date__gte
        ? store.getState().cybersecurityMapFilters.registration_date__gte
        : undefined,
      registration_date__lte: store.getState().cybersecurityMapFilters
        .registration_date__lte
        ? store.getState().cybersecurityMapFilters.registration_date__lte
        : undefined,
      company_type: store.getState().cybersecurityMapFilters.company_type.length
        ? store.getState().cybersecurityMapFilters.company_type
        : undefined,
      services: store.getState().cybersecurityMapFilters.services.length
        ? store.getState().cybersecurityMapFilters.services
        : undefined,
      other_services:
        store.getState().cybersecurityMapFilters.other_services !== undefined
          ? store.getState().cybersecurityMapFilters.other_services
          : undefined,
      has_certifications:
        store.getState().cybersecurityMapFilters.certifications !== undefined
          ? store.getState().cybersecurityMapFilters.certifications
          : undefined,
      lat: store.getState().mapInterface.viewport.latitude ?? undefined,
      lon: store.getState().mapInterface.viewport.longitude ?? undefined,
      lon_border__range:
        store.getState().cybersecurityMapFilters.lon_border__range ?? undefined,
      lat_border__range:
        store.getState().cybersecurityMapFilters.lat_border__range ?? undefined,
    };
    try {
      dispatch(MapInterfaceActionCreator.setIsLoading(true));
      const response = await cybersecurityService.fetchCybersecurityList(data);
      if (response) {
        dispatch(
          CybersecurityActionCreators.setCybersecurityInfoState(
            response.data as ICybersecurityInfoState
          )
        );
      }
      dispatch(MapInterfaceActionCreator.setIsLoading(false));
    } catch (e: string | any) {
      dispatch(
        MapInterfaceActionCreator.errorDispatch(e?.response?.data?.detail)
      );
    }
  },
  refreshFeedForCybersecuritySearchResults:
    () => async (dispatch: AppDispatch) => {
      const prevData: ICybersecurityInfoState = (store.getState() as RootState)
        .mapCybersecurityInfo;
      const { isLoading } = (store.getState() as RootState).mapInterface;
      if (isLoading) return;
      if (prevData.next === null) return;
      const page = getStoreState().mapInterface.page;
      dispatch(MapInterfaceActionCreator.setPage(page + 1));

      const servicesCategoriesFlags: { [key: string]: boolean } = (function () {
        const flags: { [key: string]: boolean } = {};
        store
          .getState()
          .cybersecurityMapFilters.service_category.forEach((category) => {
            if (cyberSecurityServiceCategories.includes(category)) {
              flags[category] = true;
            }
          });
        return flags;
      })();

      const data: IReqCybersecurityObjects = {
        ...servicesCategoriesFlags,
        keyword: [
          ...getKeywordsFromActiveSuggestions(
            store.getState().cybersecurityMapFilters.activeSuggestions
          ),
          ...(store.getState().mapFilters.keyword || []),
        ],
        edrpou: getEdrpouFromActiveSuggestions(
          store.getState().cybersecurityMapFilters.activeSuggestions
        ),
        region: getRegionsFromActiveSuggestions(
          store.getState().cybersecurityMapFilters.activeSuggestions
        ),
        account_id: store.getState().currentAccount.id,
        limit: limit,
        offset: page * limit,

        company_size: store.getState().cybersecurityMapFilters.company_size
          .length
          ? store.getState().cybersecurityMapFilters.company_size
          : undefined,
        registration_date__gte: store.getState().cybersecurityMapFilters
          .registration_date__gte
          ? store.getState().cybersecurityMapFilters.registration_date__gte
          : undefined,
        registration_date__lte: store.getState().cybersecurityMapFilters
          .registration_date__lte
          ? store.getState().cybersecurityMapFilters.registration_date__lte
          : undefined,
        company_type: store.getState().cybersecurityMapFilters.company_type
          .length
          ? store.getState().cybersecurityMapFilters.company_type
          : undefined,
        services: store.getState().cybersecurityMapFilters.services.length
          ? store.getState().cybersecurityMapFilters.services
          : undefined,

        other_services:
          store.getState().cybersecurityMapFilters.other_services !== undefined
            ? store.getState().cybersecurityMapFilters.other_services
            : undefined,
        has_certifications:
          store.getState().cybersecurityMapFilters.certifications !== undefined
            ? store.getState().cybersecurityMapFilters.certifications
            : undefined,
        lat: store.getState().mapInterface.viewport.latitude ?? undefined,
        lon: store.getState().mapInterface.viewport.longitude ?? undefined,
        lon_border__range:
          store.getState().cybersecurityMapFilters.lon_border__range ??
          undefined,
        lat_border__range:
          store.getState().cybersecurityMapFilters.lat_border__range ??
          undefined,
      };

      try {
        dispatch(MapInterfaceActionCreator.setIsLoading(true));
        const response = await cybersecurityService.fetchCybersecurityList(
          data
        );
        if (response) {
          const nextData: ICybersecurityInfoState = response.data;

          const composedData: ICybersecurityInfoState = {
            ...prevData,
            ...nextData,
            results: [...prevData.results, ...nextData.results],
          };

          dispatch(
            CybersecurityActionCreators.setCybersecurityInfoState(composedData)
          );
        }
        dispatch(MapInterfaceActionCreator.setIsLoading(false));
      } catch (e: string | any) {
        dispatch(
          MapInterfaceActionCreator.errorDispatch(e?.response?.data?.detail)
        );
      }
    },
  getCurrentCybersecurityObject:
    (id: string, account_id: number) => async (dispatch: AppDispatch) => {
      try {
        dispatch(MapInterfaceActionCreator.setIsLoading(true));

        const response = await cybersecurityService.getById(id, account_id);
        if (response) {
          dispatch(
            CybersecurityActionCreators.setSelectedCybersecurityObject(
              response.data.company
            )
          );
        }
        dispatch(MapInterfaceActionCreator.setIsLoading(false));
      } catch (e: string | any) {
        dispatch(
          MapInterfaceActionCreator.errorDispatch(e?.response?.data?.detail)
        );
      }
    },
};
